module.exports = __webpack_public_path__ + "img/left_logo.70385c45.png";